import React from 'react';
import styled, { keyframes } from 'styled-components';

import { AtiraColumn } from '../../../components/AtiraColumn';
import { AtiraRow } from '../../../components/AtiraRow';
import { Flex } from '../../../components/Flex';
import { Breakpoints } from '../../../theme/Breakpoints';
import { Rounded } from '../../../theme/Rounded';
import { Shadow } from '../../../theme/Shadow';

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const Card = styled(Flex)<{ isPopular?: boolean }>`
  border-radius: ${Rounded.lg};
  background: ${({ theme, isPopular }) =>
    isPopular
      ? `linear-gradient(270deg, ${theme.accent} 25%, ${theme.main} 50%, ${theme.accent} 75%)`
      : `linear-gradient(270deg, ${theme.bgCanvas} 25%, ${theme.onMain}00 50%, ${theme.bgCanvas} 75%)`};
  background-size: 200% 100%;
  animation: ${shimmer} 2.5s linear infinite;
  box-shadow: ${Shadow.MD};
  transition: all 0.3s ease-in-out;
  position: relative;
  height: 100vh;
  overflow: hidden;
`;

const StyledRow = styled(AtiraRow)`
  justify-content: center;

  .ant-col {
    padding-bottom: 20px;
  }

  @media (min-width: ${Breakpoints.TABLET}) {
    .ant-col:first-child {
      padding-inline-end: 5px;
    }

    .ant-col:nth-child(2) {
      padding-inline-start: 5px;
    }
  }

  @media (min-width: ${Breakpoints.DESKTOP}) {
    .ant-col:nth-child(2) {
      padding-inline-start: 0;
      padding-inline: 10px;
    }

    .ant-col:last-child {
      padding-inline-start: 5px;
    }
  }
`;

export const PlansLoading: React.FC = () => {
  return (
    <StyledRow>
      {[...Array(3)].map((_, index) => (
        <AtiraColumn xs={24} sm={24} md={12} lg={12} xl={8} key={index}>
          <Card isPopular={index === 1} />
        </AtiraColumn>
      ))}
    </StyledRow>
  );
};
